// extracted by mini-css-extract-plugin
export default {"container":"eZVy","header":"VZGF","title":"H5JJ","buttons":"OXeI","button":"CySv"};